var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/App.tsx";
import React from 'react';
import { connect } from 'react-redux';
import { useRouter } from 'Hooks';
import { GeneralModal } from 'Components/utility';
const mapState = ({
  nav: {
    location,
    initErrorStatus,
    initErrorCode,
    redirect_uri
  }
}) => {
  return {
    initErrorStatus,
    initErrorCode,
    redirect_uri,
    location
  };
};
const connector = connect(mapState);
const App = ({
  initErrorStatus,
  initErrorCode,
  redirect_uri,
  location
}) => {
  const {
    Component,
    props
  } = useRouter(location, initErrorStatus, initErrorCode, redirect_uri);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(GeneralModal, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 7
    }
  }));
};
export default connector(App);